/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyAccountingDetails } from '../models/CompanyAccountingDetails';
import type { CreateVaultSessionCommand } from '../models/CreateVaultSessionCommand';
import type { CreateVaultSessionDetails } from '../models/CreateVaultSessionDetails';
import type { DiscountCategorySettings } from '../models/DiscountCategorySettings';
import type { RefreshInvoicesCommand } from '../models/RefreshInvoicesCommand';
import type { RefreshVendorsCommand } from '../models/RefreshVendorsCommand';
import type { RegisterCompanyInAccountingSystemCommand } from '../models/RegisterCompanyInAccountingSystemCommand';
import type { UpdateDiscountCategorySettingCommand } from '../models/UpdateDiscountCategorySettingCommand';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AccountingService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns CompanyAccountingDetails Success
     * @throws ApiError
     */
    public registerCompany(
        requestBody?: RegisterCompanyInAccountingSystemCommand,
    ): CancelablePromise<CompanyAccountingDetails> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/Api/V1/Accounting',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param companyId
     * @returns CompanyAccountingDetails Success
     * @throws ApiError
     */
    public getCompanyAccountingDetails(
        companyId: string,
    ): CancelablePromise<CompanyAccountingDetails> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/Api/V1/Accounting/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }

    /**
     * @param companyId
     * @returns CompanyAccountingDetails Success
     * @throws ApiError
     */
    public syncCompanyStatus(
        companyId: string,
    ): CancelablePromise<CompanyAccountingDetails> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/Api/V1/Accounting/Sync/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }

    /**
     * @param companyId
     * @returns any Success
     * @throws ApiError
     */
    public refreshData(
        companyId?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/Api/V1/Accounting/RefreshData',
            query: {
                'companyId': companyId,
            },
        });
    }

    /**
     * @param requestBody
     * @returns CreateVaultSessionDetails Success
     * @throws ApiError
     */
    public createVaultSession(
        requestBody?: CreateVaultSessionCommand,
    ): CancelablePromise<CreateVaultSessionDetails> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/Api/V1/Accounting/CreateVaultSession',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param companyId
     * @returns DiscountCategorySettings Success
     * @throws ApiError
     */
    public getDiscountCategorySettings(
        companyId: string,
    ): CancelablePromise<DiscountCategorySettings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/Api/V1/Accounting/DiscountCategory/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }

    /**
     * @param requestBody
     * @returns DiscountCategorySettings Success
     * @throws ApiError
     */
    public updateDiscountCategorySetting(
        requestBody?: UpdateDiscountCategorySettingCommand,
    ): CancelablePromise<DiscountCategorySettings> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/Api/V1/Accounting/DiscountCategory',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public refreshVendors(
        requestBody?: RefreshVendorsCommand,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/Api/V1/Accounting/RefreshVendors',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public refreshInvoices(
        requestBody?: RefreshInvoicesCommand,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/Api/V1/Accounting/RefreshInvoices',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
